import React, { ReactNode, useState } from 'react';

export interface IHeroContextProps {
  isHero?: boolean;
  children?: ReactNode | undefined;
}

export const HeroContext = React.createContext<IHeroContextProps>({
  isHero: false,
});

export const HeroContextProvider: React.FC<IHeroContextProps> = (props) => {
  const [isHero] = useState(props.isHero);

  return (
    <HeroContext.Provider value={{ isHero }}>
      {props.children}
    </HeroContext.Provider>
  );
};
